<ng-template [ngIf]="articles" [ngIfElse]="loader">
  <div *ngFor="let article of articles" class="mb-6">
    <app-article-small [article]="article"></app-article-small>
  </div>
</ng-template>
<ng-template #loader>
  <div class="loader"><la-icon class="animate-spin" icon="spinner" size="2x"></la-icon></div>
</ng-template>
